import { defineComponent as _defineComponent } from 'vue'
import { unref as _unref, toDisplayString as _toDisplayString, createTextVNode as _createTextVNode, withCtx as _withCtx, openBlock as _openBlock, createBlock as _createBlock, createCommentVNode as _createCommentVNode, vShow as _vShow, createElementVNode as _createElementVNode, withDirectives as _withDirectives, createVNode as _createVNode, normalizeClass as _normalizeClass, createElementBlock as _createElementBlock } from "vue"

const _hoisted_1 = { class: "flex" }

import Label from "@/components/atoms/BaseLabel.vue";
import TextArea from "@/components/atoms/BaseTextArea.vue";

//Types
import type { SizesKeysType } from "@/types/sizes.type";

//Component types & definitions
import {
  VariantKeys as InputLabelVariantKeys,
  VariantsType as InputLabelVariantKeysType,
  variantCombination as InputLabelVariantCombination,
} from "@/components/molecules/inputLabel/InputLabel";


export default /*@__PURE__*/_defineComponent({
  __name: 'textAreaLabel',
  props: {
    modelValue: { default: "" },
    variant: { default: InputLabelVariantKeys.primary },
    size: {},
    block: { type: Boolean, default: false },
    full: { type: Boolean, default: true },
    label: { default: undefined },
    tag: { default: undefined },
    placeholder: {},
    required: { type: Boolean },
    rows: {}
  },
  emits: ["update:modelValue"],
  setup(__props: any, { emit: __emit }) {

//Components


const emit = __emit;

const updateText = (textValue: string) => emit("update:modelValue", textValue)


return (_ctx: any,_cache: any) => {
  return (_openBlock(), _createElementBlock("div", {
    class: _normalizeClass({
    block: _ctx.block,
    'w-full': _ctx.full,
  })
  }, [
    _createElementVNode("div", _hoisted_1, [
      (_ctx.label)
        ? (_openBlock(), _createBlock(Label, {
            key: 0,
            variant: _unref(InputLabelVariantCombination)[_ctx.variant].label,
            size: _ctx.size
          }, {
            default: _withCtx(() => [
              _createTextVNode(_toDisplayString(_ctx.label), 1)
            ]),
            _: 1
          }, 8, ["variant", "size"]))
        : _createCommentVNode("", true),
      _withDirectives(_createElementVNode("span", { class: "text-xs text-gray-400 p-1 flex flex-col justify-end" }, _toDisplayString(_ctx.tag), 513), [
        [_vShow, _ctx.tag]
      ])
    ]),
    _createVNode(TextArea, {
      modelValue: _ctx.modelValue,
      "onUpdate:modelValue": updateText,
      rows: _ctx.rows,
      full: _ctx.full,
      required: _ctx.required,
      placeholder: _ctx.placeholder
    }, null, 8, ["modelValue", "rows", "full", "required", "placeholder"])
  ], 2))
}
}

})